import React from 'react';
import { MessageSquare, RefreshCw, BarChart3 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import { getWhatsAppLink } from '../utils/whatsappHelper';
import './CustomSolutions.css';

const CustomSolutions = () => {
  const { language } = useLanguage();
  const t = translations[language].customSolutions;
  const whatsappLink = getWhatsAppLink(language);

  const icons = [MessageSquare, RefreshCw, BarChart3];

  return (
    <section className="custom-solutions section" id="custom-solutions">
      <div className="container">
        <div className="custom-solutions-header">
          <h2 className="display-medium">{t.title}</h2>
          <p className="body-large custom-solutions-description">{t.description}</p>
        </div>

        <div className="examples-grid">
          {t.examples.map((example, index) => {
            const Icon = icons[index];
            return (
              <div key={index} className="example-card">
                <div className="example-icon-wrapper">
                  <Icon size={28} className="example-icon" />
                </div>
                <h4 className="heading-2">{example.title}</h4>
                <p className="body-medium">{example.description}</p>
              </div>
            );
          })}
        </div>

        <div className="custom-solutions-cta">
          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary btn-large"
          >
            {t.cta}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CustomSolutions;